import React, { useEffect, useState, useMemo } from "react";
import { Table } from "antd";
import moment from "moment";
import { useDispatch } from "react-redux";

import { i18, trb, printComponent } from "@utilities";
import { ApplicationsActions } from "@redux";
import { DOCUMENT_TYPES } from "@config";

const getFilteredByNilRiskGroups = riskGroups => {
  const riskGroupKeys = Object.keys(riskGroups);
  const filteredRiskGroups = {};

  for (const groupKey of riskGroupKeys) {
    const groupRisks = riskGroups[groupKey].filter(risk => risk.riskScore > 0);

    if (!groupRisks.length) continue;

    filteredRiskGroups[groupKey] = groupRisks;
  }

  return filteredRiskGroups;
};

export const RenderRiskList = ({ risksEntity, finishUpload, appId, generalAppInfo, onUnMount }) => {
  const dispatch = useDispatch();
  const [pdfCreated, setPdfCreated] = useState(false);
  const containerRef = React.useRef();

  const risksWithScores = useMemo(() => {
    const filteredRisks = getFilteredByNilRiskGroups(risksEntity.riskItems);
    return {
      ...risksEntity,
      riskItems: filteredRisks
    };
  }, [risksEntity]);

  const appRisksKeys = Object.keys(risksWithScores.riskItems);

  useEffect(() => {
    if (!containerRef.current || !appId) {
      return;
    }
    (async () => {
      const blob = await printComponent(containerRef.current, "getblob");
      setPdfCreated(true);
      const formData = new FormData();
      formData.append("files", blob);
      await dispatch(
        ApplicationsActions.uploadDocumentsActions(
          appId,
          DOCUMENT_TYPES.EMPLOYEE_UPLOADED_DOC,
          formData
        )
      );
      finishUpload();
    })();
    return () => onUnMount();
  }, []);

  const columns = [
    {
      dataIndex: "riskDescription",
      key: "riskDescription",
      title: trb(i18.ApplicationsLabels.RiskDescription),
      width: "80%"
    },
    {
      dataIndex: "riskScore",
      key: "riskScore",
      title: trb(i18.ApplicationsLabels.RiskScore)
    }
  ];

  return (
    <div
      id="FileRiskListContainer"
      className="content"
      ref={containerRef}
      style={{ display: pdfCreated ? "none" : "block" }}
    >
      <div>
        <div className="general-info-panel">
          <p className="general-info-text-container">
            <b>{`${trb(i18.Labels.CompanyName)}: `}</b>
            <span className="general-info-answer">{generalAppInfo.clientName}</span>
          </p>

          <p className="general-info-text-container">
            <b>{`${trb(i18.Labels.CompanyCode)}: `}</b>
            <span className="general-info-answer">{generalAppInfo.clientCode}</span>
          </p>

          <p className="general-info-text-container">
            <b>{`${trb(i18.Labels.Date)}: `}</b>
            <span className="general-info-answer">
              {moment(new Date()).format("DD/MM/YYYY HH:mm:ss")}
            </span>
          </p>

          <p className="general-info-text-container">
            <b>{`${trb(i18.Labels.TotalScore)}: `}</b>
            <span className="general-info-answer">{risksWithScores.totalScore}</span>
          </p>
        </div>

        <div className="risk-tables-container">
          {appRisksKeys.map(groupKey => (
            <div className="risk-group-table">
              <div className="risk-group-table-title">
                {trb(i18.ApplicationsLabels?.[groupKey]) || groupKey}
              </div>
              <Table
                pagination={false}
                columns={columns}
                rowKey="id"
                size="small"
                dataSource={risksWithScores.riskItems[groupKey]}
                rowClassName="pdf-table-row"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
